exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("../../../res/img/svg/pane-collapse.svg"));
var ___CSS_LOADER_URL___1___ = urlEscape(require("../../../res/img/svg/pane-expand.svg"));

// Module
exports.push([module.id, ".Details{display:flex;flex:auto;flex-direction:column}.sidebar-open-close-button{width:24px;height:24px;flex:none;margin:0 4px;background-position:50%;background-repeat:no-repeat}.sidebar-open-close-button-isopen{background-image:url(" + ___CSS_LOADER_URL___0___ + ")}.sidebar-open-close-button-isclosed{background-image:url(" + ___CSS_LOADER_URL___1___ + ")}", ""]);

